import { render, staticRenderFns } from "./WorkflowRelationTable.vue?vue&type=template&id=ac1af672&scoped=true"
import script from "./WorkflowRelationTable.vue?vue&type=script&lang=js"
export * from "./WorkflowRelationTable.vue?vue&type=script&lang=js"
import style0 from "./WorkflowRelationTable.vue?vue&type=style&index=0&id=ac1af672&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac1af672",
  null
  
)

export default component.exports